import { Flex, HStack, Image, Link } from "@chakra-ui/react";
import React from "react";
import { rootPath } from "../../../../../routes";
import { LogoSVG } from "../../../svg";

const LogoHeader = () => {
  return (
    <Flex
      bg="white"
      boxShadow="0px 8px 16px -8px rgba(10, 100, 79, 0.12)"
      px={6}
      py={5}
      position="sticky"
      top="0px"
      zIndex="100"
    >
      <HStack as={Link} pb={1} h="full" href={rootPath()}>
        <Image src={LogoSVG} h={8} />
      </HStack>
    </Flex>
  );
};

export default LogoHeader;
